import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  addBtn: {
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightSemiBold,
    fontSize: theme.typography.pxToRem(18)
  },
  menuPopper: {
    zIndex: 10,
    '& li:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white
    }
  },
  tabsWrapper: {
    flexGrow: 1,
    width: '100%',
    '& > .MuiPaper-root': {
      backgroundColor: theme.palette.primary.lighter,
      color: theme.palette.common.white,
      '& button': {
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightSemiBold,
        '&:not(.Mui-selected)': {
          color: theme.palette.common.white
        }
      }
    },
    '& .MuiTabs-indicator': {
      height: 4
    }
  },
}))
